import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BigNumber from "bignumber.js";
import { CardRow } from "components/card";
import { Content, ContentBox, ContentEmpty } from "components/content";
import Tabs from "components/tab/Tabs";
import { NumberText } from "components/texts";
import { useRewards } from "hooks/useRewards";
import { useWalletProvider } from "hooks/useWalletProvider";
import { NextSeo } from "next-seo";
import React, { useCallback, useMemo, useState } from "react";
import { Container, Header } from "../components";
var Main = function() {
    var ref = useRewards(), endedRewards = ref.endedRewards, ongoingRewards = ref.ongoingRewards;
    var connected = useWalletProvider().connected;
    var tabItems = useMemo(function() {
        return [
            {
                text: "Current",
                value: 1
            },
            {
                text: "Ended",
                value: 2
            }
        ];
    }, []);
    var ref1 = useState(tabItems[0]), activeTab = ref1[0], setActiveTab = ref1[1];
    var onTabClick = useCallback(function(item) {
        return setActiveTab(item);
    }, tabItems);
    var displayCampaigns = useMemo(function() {
        if (activeTab.value === 1) {
            return ongoingRewards;
        }
        return endedRewards;
    }, [
        activeTab,
        ongoingRewards,
        endedRewards
    ]);
    return /*#__PURE__*/ _jsx(Content, {
        children: /*#__PURE__*/ _jsxs(ContentBox, {
            title: "Rewards",
            className: "space-y-3",
            headerRight: /*#__PURE__*/ _jsx(Tabs, {
                className: "md:mt-6",
                activeItem: activeTab,
                items: tabItems,
                onTabClick: onTabClick
            }),
            children: [
                !connected && /*#__PURE__*/ _jsx(ContentEmpty, {
                    children: "Connect your wallet to check your rewards"
                }),
                connected && /*#__PURE__*/ _jsxs("div", {
                    className: "",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "hidden md:grid grid-cols-1 md:grid-cols-3 items-center gap-4 px-3 md:px-4 rounded-lg mb-4 text-xs text-secondary",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    children: "Name"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    children: "Your earned"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    children: "Per day"
                                })
                            ]
                        }),
                        Object.keys(displayCampaigns).length === 0 && /*#__PURE__*/ _jsx(ContentEmpty, {
                            children: "No rewards earned yet"
                        }),
                        Object.keys(displayCampaigns).map(function(campaign) {
                            var rewards = displayCampaigns[campaign];
                            return /*#__PURE__*/ _jsxs("div", {
                                className: "grid grid-cols-1 md:grid-cols-3 items-center gap-4 py-3 sm:py-6 px-3 sm:px-4 rounded-lg border-secondary border mb-2",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "font-bold",
                                        children: rewards[0].campaign.name
                                    }),
                                    /*#__PURE__*/ _jsx(CardRow, {
                                        label: "Your earned",
                                        center: false,
                                        children: rewards.map(function(r) {
                                            return /*#__PURE__*/ _jsx(NumberText, {
                                                className: "text-sm",
                                                defaultIfNull: "N/A",
                                                suffix: " ".concat(r.token.symbol),
                                                value: new BigNumber(r.rewardAmountFloat),
                                                displayDecimals: r.token.decimals
                                            }, "earned_".concat(r.id));
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(CardRow, {
                                        label: "Per day",
                                        center: false,
                                        children: rewards.map(function(r) {
                                            return /*#__PURE__*/ _jsx(NumberText, {
                                                className: "text-sm",
                                                defaultIfNull: "N/A",
                                                suffix: " ".concat(r.token.symbol),
                                                value: new BigNumber(r.rewardAmountFloatPerDay),
                                                displayDecimals: r.token.decimals
                                            }, "perday_".concat(r.id));
                                        })
                                    })
                                ]
                            }, "campaign_".concat(campaign));
                        })
                    ]
                })
            ]
        })
    });
};
var Page = function() {
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(NextSeo, {
                title: "Rewards"
            }),
            /*#__PURE__*/ _jsx(Header, {}),
            /*#__PURE__*/ _jsx(Main, {})
        ]
    });
};
export default Page;
